import React from "react";
import { FONT } from "../constants";
import { C } from "../styles";

interface Props {
  isOpen: boolean;
  isDefault: boolean;
  isActive: boolean;
  flipUp: boolean;
  onToggle: (e: React.MouseEvent) => void;
  onEdit: () => void;
  onDuplicate: () => void;
  onToggleActive: () => void;
  onDelete: () => void;
}

export default function PayTypeKebabMenu({
  isOpen,
  isDefault,
  isActive,
  flipUp,
  onToggle,
  onEdit,
  onDuplicate,
  onToggleActive,
  onDelete,
}: Props) {
  const itemStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: 9,
    width: "100%",
    padding: "8px 12px",
    background: "none",
    border: 0,
    fontSize: 13,
    color: C.ink,
    cursor: "pointer",
    borderRadius: 5,
    fontFamily: FONT,
    textAlign: "left",
  };

  const iconStyle: React.CSSProperties = {
    color: (C as any).muted,
    flex: "0 0 13px",
  };

  return (
    <div
      style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", position: "relative" }}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        onClick={onToggle}
        style={{
          background: "none",
          border: "1px solid transparent",
          borderRadius: 5,
          width: 28,
          height: 28,
          cursor: "pointer",
          color: (C as any).faint,
          display: "grid",
          placeItems: "center",
          fontFamily: FONT,
        }}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
          <circle cx="12" cy="5" r="1.5" />
          <circle cx="12" cy="12" r="1.5" />
          <circle cx="12" cy="19" r="1.5" />
        </svg>
      </button>
      {isOpen && (
        <div
          style={{
            position: "absolute",
            right: 0,
            background: "#fff",
            border: "1px solid " + C.line,
            borderRadius: 8,
            boxShadow: "0 8px 24px rgba(10,26,30,.12)",
            minWidth: 160,
            zIndex: 100,
            padding: 4,
            ...(flipUp ? { bottom: 32 } : { top: 32 }),
          }}
        >
          <button onClick={(e) => { e.stopPropagation(); onEdit(); }} style={itemStyle}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={iconStyle}>
              <path d="M12 20h9M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
            </svg>
            Edit
          </button>
          <button onClick={(e) => { e.stopPropagation(); onDuplicate(); }} style={itemStyle}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={iconStyle}>
              <rect x="9" y="9" width="13" height="13" rx="2" />
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
            </svg>
            Duplicate
          </button>
          <button onClick={(e) => { e.stopPropagation(); onToggleActive(); }} style={itemStyle}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={iconStyle}>
              <circle cx="12" cy="12" r="10" />
              <path d="M8 12h8" />
            </svg>
            {isActive ? "Deactivate" : "Activate"}
          </button>
          {!isDefault && (
            <>
              <div style={{ height: 1, background: (C as any).lineSoft, margin: "4px 8px" }} />
              <button
                onClick={(e) => { e.stopPropagation(); onDelete(); }}
                style={{ ...itemStyle, color: "#B53B2E" }}
              >
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ flex: "0 0 13px" }}>
                  <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                </svg>
                Delete
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
}